import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import TgBestPracticesContent from "./Content/TgBestPracticesContent.tsx";
import styles from "./TgBestPractices.module.scss";

const TgBestPractices = () => {
	return (
		<Box className={styles.container}>
			<TgBestPracticesContent hideHeader />
		</Box>
	);
};

export default observer(TgBestPractices);
